import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const AddMarketplaceDrawer = ({ open, onClose, onCreate }) => {
  const [form, setForm] = React.useState({ name: '', platform_url: '', fee_percent: '', fixed_fee_per_unit: '', notes: '' });
  const handle = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex justify-end z-40">
      <div className="w-full max-w-md bg-card border border-border rounded-l-2xl p-6 overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <Icon name="ShoppingCart" size={18} className="text-primary" />
            <h3 className="text-lg font-semibold">Novo Marketplace</h3>
          </div>
          <Button variant="ghost" onClick={onClose} iconName="X">Fechar</Button>
        </div>
        <div className="space-y-4">
          <Input label="Nome" placeholder="Shopee, Mercado Livre..." value={form?.name} onChange={(e) => handle('name', e.target.value)} />
          <Input label="URL da Plataforma" placeholder="https://..." value={form?.platform_url} onChange={(e) => handle('platform_url', e.target.value)} />
          <div className="grid grid-cols-2 gap-4">
            <Input label="Taxa por transação (%)" type="number" step="0.1" placeholder="12.0" value={form?.fee_percent} onChange={(e) => handle('fee_percent', e.target.value)} />
            <Input label="Taxa fixa por transação (R$)" type="number" step="0.01" placeholder="0.00" value={form?.fixed_fee_per_unit} onChange={(e) => handle('fixed_fee_per_unit', e.target.value)} />
          </div>
          <Input label="Notas" placeholder="Observações" value={form?.notes} onChange={(e) => handle('notes', e.target.value)} />
        </div>
        <div className="flex justify-end mt-6">
          <Button iconName="Save" onClick={() => onCreate(form)}>Salvar</Button>
        </div>
      </div>
    </div>
  );
};

export default AddMarketplaceDrawer;